import { List } from "../Components/index.js";

export default [
    {
        path: "/reports/task/status",
        component: List,
        name: "report.letter.office.task",
        meta: {
            requiresAuth: true,
        },
    },
];
